export function initDropdown() {
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-dropdown-trigger]');

    if (trigger) {
      const container = trigger.closest('[data-dropdown]');
      if (!container) return;
      const menu = container.querySelector('[data-dropdown-menu]');
      if (!menu) return;

      const isOpen = !menu.classList.contains('hidden');

      closeAllDropdowns();

      if (!isOpen) {
        menu.classList.remove('hidden');
        container.setAttribute('data-open', '');
      }
      return;
    }

    if (!e.target.closest('[data-dropdown]')) {
      closeAllDropdowns();
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAllDropdowns();
  });
}

function closeAllDropdowns() {
  document.querySelectorAll('[data-dropdown-menu]:not(.hidden)').forEach(menu => {
    menu.classList.add('hidden');
  });
  document.querySelectorAll('[data-dropdown][data-open]').forEach(c => {
    c.removeAttribute('data-open');
  });
}
